import { useState } from "react";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import {
  ActionLink,
  IconComponent,
  IconName,
  MobilePopoverCard,
} from "@hopper-b2b/ui";
import { Typography } from "@material-ui/core";
import clsx from "clsx";
import Info from "../../../assets/client/info-outlined.svg?react";
import Luggage from "../../../assets/client/luggage.svg?react";
import styles from "./SelfTransferDisclaimer.module.scss";

export interface ISelfTransferDisclaimerProps {
  modal?: boolean;
}

export const SelfTransferDisclaimer = ({
  modal,
}: ISelfTransferDisclaimerProps) => {
  const { t } = useI18nContext();
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = (e?: React.SyntheticEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    setOpenModal(true);
  };
  const handleCloseModal = () => setOpenModal(false);

  return (
    <>
      <div className={clsx(styles.SelfTransferDisclaimer, { modal })}>
        {modal ? (
          <>
            <Luggage className={styles.SelfTransferDisclaimerIcon} />
            <div className={styles.SelfTransferDisclaimerContent}>
              {t("virtualInterline.selfTransferDisclaimer")}
              <Info
                onClick={(e) => {
                  handleOpenModal(e);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleOpenModal(e);
                  }
                }}
                role="button"
                tabIndex={0}
                aria-label={t("virtualInterline.selfTransferModal.header")}
              />
            </div>
          </>
        ) : (
          <Trans
            i18nKey="virtualInterline.selfTransferDisclaimerLearnMore"
            components={[
              <span
                onClick={(e) => {
                  handleOpenModal(e);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleOpenModal(e);
                  }
                }}
                role="button"
                tabIndex={0}
                aria-label={t("virtualInterline.selfTransferModal.header")}
                className={styles.SelfTransferDisclaimerLearnMore}
              />,
            ]}
          />
        )}
      </div>
      <MobilePopoverCard
        className={styles.SelfTransferDisclaimerModal}
        contentClassName={styles.SelfTransferDisclaimerModalContent}
        open={openModal}
        onClose={handleCloseModal}
        headerElement={
          <Typography
            className="mobile-flight-details-modal-header"
            variant="h2"
          >
            <span className="title">
              {t("virtualInterline.selfTransferModal.header")}
            </span>
            <ActionLink
              className="filter-close-button"
              content={
                <IconComponent
                  ariaLabel={t("modalClose.ariaLabel")}
                  className={clsx("close-button-icon")}
                  name={IconName.Close}
                />
              }
              label={t("modalClose.label")}
              onClick={handleCloseModal}
            />
          </Typography>
        }
      >
        <div className="content">
          <div className="description">
            <h5>{t("virtualInterline.selfTransferModal.subtitle")}</h5>
            <p>{t("virtualInterline.selfTransferModal.description")}</p>
          </div>
          <div className="details">
            <div className="details-content">
              <div className="steps">
                <h6>{t("virtualInterline.selfTransferModal.steps.title")}</h6>
                <Trans
                  i18nKey="virtualInterline.selfTransferModal.steps.first"
                  components={[<b />]}
                />
                <Trans
                  i18nKey="virtualInterline.selfTransferModal.steps.second"
                  components={[<b />]}
                />
              </div>
              <div className="international-flights">
                <Trans
                  i18nKey="virtualInterline.selfTransferModal.internationalFlights"
                  components={[<b />]}
                />
              </div>
            </div>
          </div>
        </div>
      </MobilePopoverCard>
    </>
  );
};
